module.exports = __webpack_public_path__ + "img/map-icon.05fd2746.svg";